import { openLeoOperatorAssistantGuide, leoOperatorAssistantBus } from '@/utils/leoOperatorAssistant'

export const COMMERCE_OPS_UNIFY_PLAYBOOK = 'platform_commerce_ops_unify_r1'

let pendingPlaybook = null

export function takePendingSmartGuidePlaybook () {
  const id = pendingPlaybook
  pendingPlaybook = null
  return id
}

export function queuePendingSmartGuidePlaybook (payload) {
  pendingPlaybook = payload
}

/** 打开 SOC 助手并开始「价目＋全景」标准流水线。 */
export function startCommerceOpsUnifyPipeline () {
  pendingPlaybook = COMMERCE_OPS_UNIFY_PLAYBOOK
  openLeoOperatorAssistantGuide()
  leoOperatorAssistantBus.$emit('start-smart-guide-playbook', COMMERCE_OPS_UNIFY_PLAYBOOK)
}



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/utils/startCommerceOpsUnifyPipeline.js